var exports = {
  "mP": "marginBoxFixed-ZjRXZ",
  "DK": "menuAnchorFixed-ZjRXZ",
  "tP": "highlightFixed-ZjRXZ",
};

module.exports = exports;
